import { put, take, takeLatest } from 'redux-saga/effects';
import { storage } from 'src/constants/storage';
import { peekdataApi, reportsApi } from 'src/services/api';
import { IAction } from '../action';
import { actionTypes, loadReportsList } from './actions';

function* getReportsList() {
  try {
    const sessionID = localStorage.getItem(storage.sessionIdKey);
    const reportsList = yield reportsApi.getReportsList(sessionID);

    yield put({
      type: actionTypes.receiveReportsList,
      payload: {
        data: reportsList,
        isFetching: false,
        error: null,
        errorTimestamp: null,
      },
    });
  } catch (error) {
    yield put({
      type: actionTypes.receiveReportsList,
      payload: {
        data: null,
        isFetching: false,
        error: error.toString(),
        errorTimestamp: new Date(),
      },
    });
  }
}

function* downloadReport(action: IAction) {
  try {
    const sessionID = localStorage.getItem(storage.sessionIdKey);
    const report = yield reportsApi.getReport(sessionID, action.payload);

    const request = report && report.dataRequest;
    const title = report && report.title && report.title.replace(/ /g, '_').toLowerCase();

    const file = yield peekdataApi.data.getCSV(request);

    const type = 'data:text/csv;charset=utf-8;';
    const fileName = (title && `${title}.csv`) || 'file.csv';

    const blob = new Blob([file], { type });

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, fileName);
    } else {
      const data = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      document.body.appendChild(link);

      link.setAttribute('style', 'display: none');
      link.href = data;
      link.download = fileName;
      link.click();

      window.URL.revokeObjectURL(data);
      link.remove();
    }

    yield put({
      type: actionTypes.reportDownloadStatus,
      payload: {
        data: true,
        isFetching: false,
        error: null,
        errorTimestamp: null,
      },
    });
  } catch (error) {
    yield put({
      type: actionTypes.reportDownloadStatus,
      payload: {
        data: false,
        isFetching: false,
        error: 'Unable to download file',
        errorTimestamp: new Date(),
      },
    });
  }
}

function* removeReport(action: IAction) {
  try {
    const sessionID = localStorage.getItem(storage.sessionIdKey);

    yield reportsApi.removeReport(sessionID, action.payload);

    yield put(loadReportsList());
    yield take(actionTypes.receiveReportsList);

    yield put({
      type: actionTypes.reportRemoveStatus,
      payload: {
        data: true,
        isFetching: false,
        error: null,
        errorTimestamp: null,
      },
    });
  } catch (error) {
    yield put({
      type: actionTypes.reportRemoveStatus,
      payload: {
        data: false,
        isFetching: false,
        error: error.toString(),
        errorTimestamp: new Date(),
      },
    });
  }
}

export const reportManagerSaga = [
  takeLatest(actionTypes.requestReportsList, getReportsList),
  takeLatest(actionTypes.downloadReport, downloadReport),
  takeLatest(actionTypes.removeReport, removeReport),
];
